import cx from 'classnames'
import styles from '../../Dashboard/DashboardReminder.css'
import { HyperLink } from '../../Common/Form'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'

const DASHBOARD_FEATURE_URI = `${CDN}/supplier/seller-dashboard-202601.pdf`
export const DASHBOARD_REMINDER_ANCHOR = 'dashboard-reminder'

const DashboardReminder = props => {
  const {
    className,
    ...restProps
  } = props
  const clz = cx(
    styles.DashboardReminder,
    {
      [className]: className
    }
  )

  return (
    <div
      className={clz}
      {...restProps}
    >
      <a name={DASHBOARD_REMINDER_ANCHOR} />
      <p><b>儀表板小提醒：</b></p>
      <p>* 顯示之金額皆為買家實付金額。不含運費。</p>
      <p>* 訂單成立之計算時機為訂購日，即買家訂購成功之訂單。</p>
      <p>* 瀏覽相關數據由 Google Analytics (GA) 提供。包含瀏覽量、訪客數、停留時間等。</p>
      <p>
        * 功能說明，請看
        <HyperLink
          target='_blank'
          href={DASHBOARD_FEATURE_URI}
        >
          這裡
        </HyperLink>
        。
      </p>
    </div>
  )
}

export default DashboardReminder
